import { render, staticRenderFns } from "./FontLibary.vue?vue&type=template&id=7894f6a2&"
import script from "./FontLibary.vue?vue&type=script&lang=js&"
export * from "./FontLibary.vue?vue&type=script&lang=js&"
import style0 from "./FontLibary.vue?vue&type=style&index=0&id=7894f6a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports